// extracted by mini-css-extract-plugin
export default {"ctn":"Synchronization_ctn_zMiGb","badge":"Synchronization_badge_EJ6Xy","table":"Synchronization_table_ZP5Mt"};